import VinEntry from './VinEntry';

export default VinEntry;